module.exports = __webpack_public_path__ + "img/detail4.7362370c.jpg";